import {
  ApplicationConfig,
  importProvidersFrom,
  inject,
  isDevMode,
  provideAppInitializer,
} from "@angular/core";
import { provideRouter, withInMemoryScrolling } from "@angular/router";
import { provideZonelessChangeDetection } from "@angular/core";
import { provideAnimations } from "@angular/platform-browser/animations";
import { provideServiceWorker } from "@angular/service-worker";
import { HttpClient, provideHttpClient, withInterceptors } from "@angular/common/http";
import { Title } from "@angular/platform-browser";
import { initializeApp, provideFirebaseApp } from "@angular/fire/app";
import { provideAuth, getAuth } from "@angular/fire/auth";
import { provideFirestore, getFirestore } from "@angular/fire/firestore";
import { provideFunctions, getFunctions } from "@angular/fire/functions";
import { provideMessaging, getMessaging } from "@angular/fire/messaging";
import { FIREBASE_OPTIONS } from "@angular/fire/compat";
import { TranslateLoader, TranslateModule } from "@ngx-translate/core";
import { TranslateHttpLoader } from "@ngx-translate/http-loader";
import { provideLottieOptions } from "ngx-lottie";
import { NgbModule } from "@ng-bootstrap/ng-bootstrap";
import { appRoutes } from "./app.routes";
import { environment } from "@environments/environment";
import { DomainService } from "@shared/services/domain/domain.service";
import { PwaInstallService } from "@shared/services/pwa/pwa-install.service";
import { offlineInterceptor } from "@core/interceptors/offline.interceptor";
import { authInterceptor } from "@core/interceptors/auth.interceptor";
import { errorInterceptor } from "@core/interceptors/error.interceptor";
import { requestTransformInterceptor } from "@core/interceptors/request-transform.interceptor";
import { responseTransformInterceptor } from "@core/interceptors/response-transform.interceptor";
import { fallbackApiInterceptor } from "@core/interceptors/fallback-api.interceptor";
function httpTranslateLoader(http: HttpClient) {
  return new TranslateHttpLoader(http);
}

export const appConfig: ApplicationConfig = {
  providers: [
    provideZonelessChangeDetection(),
    provideRouter(appRoutes, withInMemoryScrolling({ scrollPositionRestoration: "top"})),
    provideAnimations(),
    provideServiceWorker("excuela-sw.js", {
      enabled: !isDevMode(),
      registrationStrategy: "registerWhenStable:30000",
    }),
    provideHttpClient(
      withInterceptors([
        offlineInterceptor,
        authInterceptor,
        requestTransformInterceptor,
        fallbackApiInterceptor,
        responseTransformInterceptor,
        errorInterceptor,
      ]),
    ),
    provideFirebaseApp(() => initializeApp(environment.firebase)),
    provideAuth(() => getAuth()),
    provideFirestore(() => getFirestore()),
    provideFunctions(() => getFunctions()),
    provideMessaging(() => getMessaging()),
    provideLottieOptions({ player: () => import("lottie-web") }),
    importProvidersFrom(
      NgbModule,
      TranslateModule.forRoot({
        defaultLanguage: "es",
        loader: {
          provide: TranslateLoader,
          useFactory: httpTranslateLoader,
          deps: [HttpClient],
        },
      })
    ),
    { provide: FIREBASE_OPTIONS, useValue: environment.firebase },
    Title,
    // No devolver la promesa: hacerlo bloquearía el bootstrap.
    provideAppInitializer((): void => {
      void inject(DomainService).ready;
      inject(PwaInstallService);
    }),
  ],
};
